import api from '@api/index';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async FETCH_DEVICE_DISASTER_YN(_, userId) {
    const response = await api.deviceSetting.fetchedDeviceDisasterYN(userId);
    return response.data.items.disaster_yn;
  },

  EDIT_DEVICE_DISASTER_YN(_, reqInfo) {
    return api.deviceSetting.editDeviceDisasterYN(reqInfo);
  },

  EDIT_FIXED_BRIGHTNESS(_, reqInfo) {
    return api.deviceSetting.editFiexedBrightness(reqInfo);
  },

  EDIT_FIXED_POWER(_, reqInfo) {
    return api.deviceSetting.editFiexedPower(reqInfo);
  },

  EDIT_SCHEDULE_BRIGHT(_, reqInfo) {
    return api.deviceSetting.editScheduleBright(reqInfo);
  },

  EDIT_SCHEDULE_POWER(_, reqInfo) {
    return api.deviceSetting.editSchedulePower(reqInfo);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
